import React from 'react';
import { motion } from 'framer-motion';
export function BrandMark() {
  return <div className="flex items-center gap-2.5" data-id="element-15">
      <motion.div className="w-11 h-11 flex items-center justify-center" whileHover={{
      rotate: 10,
      scale: 1.1
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 10
    }} data-id="element-16">
        <img src="https://cdn.magicpatterns.com/uploads/iYTr1RHCfauxcBJJjaVbqG/image.png" alt="Kraya elephant logo" className="w-full h-full object-contain" data-id="element-17" />
      </motion.div>
      <h1 data-id="element-18">
        <img src="https://cdn.magicpatterns.com/uploads/duZVRoxveAoyiFsJUcxDWj/image.png" alt="Kraya" className="h-7 w-auto object-contain" data-id="element-19" />
      </h1>
    </div>;
}